Vue.component("HotspotRender", {

    props: ["hotspots"],

    // goto: proberly needs to be an event.
    // events: 
    //  makeActiveHotspot
    // - closeAllContent
    // - scene goto / change Scene
    template: `
       <ul id="hotspotlist">
        <component  
            :is="getHotspotComponent(hotspot)" 
            v-for="(hotspot, index) in hotspotList" 
            :settings="getHospotSettings(hotspot)"
            :hotspot="createHotspotProperties(hotspot)"
            :index="index"
            :key="keyGen('hs', index)"
            :resetHotspot="resetHotspot"
            :activeHotspot="activeHotspot"
            @makeActiveHotspot="activeHotspot = index"
            @goto="clicked"
            @resetHotspotAnimationCycle="resetHotspotAnimationCycle" >
        </component>
        </ul>
    `,

    data() {
        return {
            resetHotspot: false,
            activeHotspot: -1
        }
    },

    mounted () {
        this.eventHandlers = {
            "scene-closing-all-components": () => {
                this.activeHotspot = -1;
            }
        }
        Object.keys(this.eventHandlers).forEach(event => {
            app.radio.$on(event,  this.eventHandlers[event])
        })
        
    },

    destroyed () {
        Object.keys(this.eventHandlers).forEach(event => {
            app.radio.$off(event,  this.eventHandlers[event])
        })
    },

    computed: {
        hotspotList () {
            return ConditionalFilters.filter(this.hotspots);
        }
    },

 

    methods: {
        clicked(hotspot) {
            this.$emit("goto", hotspot);
        },
        keyGen(prefix, index) {
            return prefix + "-" + index;
        },
        getComponentConfiguration(name) {
            return touchKit.utils.objCopy(config[name]);
        },
        getHospotSettings() {
            return this.getComponentConfiguration('HOTSPOT').settings
        },
        resetHotspotAnimationCycle() {
            // reset current cycle animation for hotspots. for cycles like
            //  pulse where the timings have to work in relation to each other.
            if (this.resetHotspot == false)
                this.resetHotspot = true;
            setTimeout(() => {
                this.resetHotspot = false;
            }, 1500);
        },
        getHotspotComponent(hotspot) {

            if (hotspot.hasOwnProperty("hotspotstyle") && hotspot.hotspotstyle.hasOwnProperty("component")) {
                return hotspot.hotspotstyle.component;
            }
            return this.getComponentConfiguration('HOTSPOT').componentName
        },
        createHotspotProperties(hotspot) {




            var copy = { ...hotspot };
            delete copy.hotspots;
            delete copy.hotspotstyle;

            var h = {
                // id: hotspot.id,
                // title: hotspot.title,
                // x: hotspot.x,
                // y: hotspot.y,

                ...copy,

                hotspots: hotspot.hotspots ? true : false,
                hotspotstyle: hotspot.hotspotstyle ? hotspot.hotspotstyle : {}
            };



            var hotspotComponentReferenceData = touchKit.PageManager.getContent(hotspot.id);

            var result = {
                component: hotspotComponentReferenceData ? hotspotComponentReferenceData.data : {},
                type: hotspotComponentReferenceData ? hotspotComponentReferenceData.type : ""
            };




            Object.assign(result, h);



            return result;
        },
    }
})